import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/FullScreenButton.module.scss';

type FullScreenButtonType = {
  elementId: string;
  position: 'topRight' | 'topLeft' | 'bottomRight' | 'bottomLeft';
};

const toggleFullScreen = (element: HTMLElement): void => {
  if (!document.fullscreenElement) {
    element.requestFullscreen();
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
};

const FullScreenButton: React.FunctionComponent<FullScreenButtonType> = (props: FullScreenButtonType) => {
  const { t } = useTranslation();

  return (
    <button
      className={`${styles.fullscreen} ${styles[props.position || 'topRight']} ${document.fullscreenElement ? styles.exit : ''}`}
      onClick={(): void => {
        const element = document.getElementById(props.elementId);
        if (element) {
          toggleFullScreen(element);
        }
      }}
      aria-label={document.fullscreenElement ? t('common:general.exitFullscreen') : t('common:general.fullscreen')}
      title={document.fullscreenElement ? t('common:general.exitFullscreen') : t('common:general.fullscreen')}
    />
  );
};

export default FullScreenButton;
